import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryTags = createRoutine('FETCH_INVENTORY_TAGS');
export const createInventoryTags = createRoutine('CREATE_INVENTORY_TAGS');
export const createInventoryTag = createRoutine('CREATE_INVENTORY_TAG');
export const updateInventoryTag = createRoutine('UPDATE_INVENTORY_TAG');
export const deleteInventoryTag = createRoutine('DELETE_INVENTORY_TAG');
